import { Injectable, Inject } from '@angular/core';
import { HttpClient, HttpEventType, HttpProgressEvent, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { DeleteFilesViewModel, DocumentModule, UploadedFileViewModel } from './document_uploader.types';
import { NotificationService } from '../../_infrastructure/classes/services/notification.service';

@Injectable()
export class DocumentUploaderService {
    private baseEndpoint = 'api/core/';

    constructor(
        private http: HttpClient,
        @Inject('BASE_URL') private baseUrl: string,
        protected notificacionService: NotificationService,
    ) {}

    public upload(fileToUpload: File, maxSize: number, documentModule: DocumentModule) {
        const endpoint = this.getEndpoint(documentModule) + '/post/';
        let formData = new FormData();
        formData.append('file', fileToUpload, fileToUpload.name);
        formData.append('maxSize', maxSize.toString());

        return this.http
            .post<any>(endpoint, formData, {
                reportProgress: true,
                observe: 'events',
            })
            .pipe(
                map(event => {
                    switch (event?.type) {
                        case HttpEventType.UploadProgress:
                            return { status: 'progress', message: this.getLoadingProgress(event) };

                        case HttpEventType.Response:
                            return { status: 'response', message: event?.body };

                        default:
                            return { status: 'error', message: 'Error http en la carga del archivo' };
                    }
                }),
            );
    }

    /**
     *
     * @param file UploadedFileViewModel
     * @param documentModule: DocumentModule
     * @returns Observable<HttpResponse<Blob>>
     */
    public download(file: UploadedFileViewModel, documentModule?: DocumentModule): Observable<HttpResponse<Blob>> {
        const endpoint = this.getEndpoint(documentModule) + '/postDownload';
        return this.http.post(endpoint, file, { observe: 'response', responseType: 'blob' }).pipe();
    }

    public delete(guid: string, documentModule: DocumentModule): Observable<any> {
        const endpoint = this.getEndpoint(documentModule) + '/' + guid;
        return this.http.delete<UploadedFileViewModel>(endpoint).pipe();
    }

    /**
     * TODO: scalero1 - quedaría implementar el método en el resto de controllers
     * Por ahora solo implementado en DocController.
     * Devuelve el número de ficheros eliminados.
     * @param guids string[]
     * @param documentModule DocumentModule
     * @returns Observable<number>
     */
    public deleteList(guids: string[], documentModule: DocumentModule): Observable<any> {
        if (documentModule !== DocumentModule.Gestor) {
            throw new Error('Método no implementado para el módulo indicado');
        }

        const endpoint = this.getEndpoint(documentModule);
        const payload: DeleteFilesViewModel = new DeleteFilesViewModel();
        payload.guids = guids;
        payload.module = documentModule;
        return this.http.post<any>(endpoint + '/deleteList', payload);
    }

    getLoadingProgress(event: HttpProgressEvent) {
        if (event === null) {
            return 0;
        }
        if (event.total === 0) {
            return 0;
        }
        return Math.round((100 * event.loaded) / event.total!);
    }

    private getEndpoint(documentModule?: DocumentModule): string {
        return this.baseUrl + this.baseEndpoint + (documentModule ? documentModule : DocumentModule.Default);
    }
}
